import React, { Component } from 'react';
import { EditGroupProps, EditGroupState } from '../../interfaces/group';
import { connect } from 'react-redux';
import jwt from 'jsonwebtoken';
import Topbar from '../topbar/topbar';
import Sidebar from '../sidebar/sidebar';
import Footer from '../footer/footer';
import { Link, Redirect } from 'react-router-dom';
import { storesList, getGroup, updateGroup, getStoreByGroup } from '../../redux/actions/groupStore';
import Select from 'react-select';
import CheckChanges from '../confirmOnLeave';
import config from '../config/setting';
import { companyList } from '../../redux/actions/company';
import { logoutUser } from '../../redux/actions/user';

class EditGroup extends Component<any, EditGroupState> {
  constructor(props: any) {
    super(props);

    this.state = {
      name: '',
      description: '',
      store: [],
      company: '',
      territary: '0',
      user: '',
      status: '1',
    };

    this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { match, getGroup, getStoreByGroup, companyList } = this.props;
    const groupId = match?.params?.id;

    companyList();

    if (!groupId) {
      return;
    }

    getGroup(groupId);
    getStoreByGroup(groupId);
  }

  componentDidUpdate(prevProps: EditGroupProps) {
    if (this.props.group && prevProps.group !== this.props.group) {
      const group: any = this.props.group;

      this.setState({
        name: group.name || '',
        description: group.description || '',
        company: group.company?.id || '',
        territary:
          group.territary !== undefined && group.territary !== null
            ? String(group.territary)
            : '0',
        status:
          group.status !== undefined && group.status !== null
            ? String(group.status)
            : '1',
        user: '',
      });
    }

    if (
      Array.isArray(this.props.groupStores) &&
      this.props.groupStores !== prevProps.groupStores
    ) {
      const storeIds = this.props.groupStores.map(
        (gs: any) => gs.store && gs.store.id,
      );

      this.setState({ store: storeIds.filter((id: any) => id != null) });
    }
  }

  handleInputChange(event: { target: { name: any; value: any } }) {
    if (event.target.value && event.target.value[0] === ' ') {
      return;
    }

    this.setState({
      [event.target.name]: event.target.value,
    } as any);
  }

  handleItemsInputChange = (e: any) => {
    const array: any[] = [];

    e &&
      e.forEach((obj: any) => {
        array.push(obj.value);
      });

    this.setState({ store: array });
  };

  handleCompanyInputChange = (e: any) => {
    if (e && e.value > 0) {
      this.setState({ company: e.value });
      this.props.storesList(e.value);
      return;
    }

    this.setState({ company: '' });
  };

  isGroupReady = () => {
    const { name, store, territary, status, company, description } = this.state;
    return (
      name !== '' &&
      (store || []).length > 0 &&
      territary !== '' &&
      company !== '' &&
      description !== '' &&
      status !== ''
    );
  };

  handleSaveBtnClick() {
    const { match } = this.props;
    const groupId = match?.params?.id;

    if (!groupId) {
      return;
    }

    const { name, description, store, company, territary, status, user } =
      this.state;

    const data = {
      name,
      description,
      store,
      territary,
      status,
      user_id: user,
      company,
      isActive: config.ACTIVE,
    };

    this.props.updateGroup(groupId, data);
  }

  render() {
    if (sessionStorage.token) {
      jwt.verify(
        sessionStorage.token,
        config.secretKey,
        (err: any, decoded: any) => {
          if (err) {
            this.props.logoutUser();
          }
        },
      );
    } else {
      return <Redirect to="/" />;
    }

    let msg;
    let messcolor;
    const { isUpdated, message } = this.props as any;
    const stores = this.props.stores || [];
    const companies = this.props.companies || [];

    const storeData: any[] = [];
    stores.forEach((element: any) => {
      const store = { label: element.name, value: element.id };
      storeData.push(store);
    });

    const companyData: any[] = [];
    companies.forEach((element: any) => {
      const company = { label: element.company_name, value: element.id };
      companyData.push(company);
    });

    const selectedCompany =
      companyData.find((c: any) => c.value === this.state.company) || null;

    const selectedStores = storeData.filter((s: any) =>
      (this.state.store || []).includes(s.value),
    );

    if (isUpdated) {
      msg = message;
      messcolor = 'green';
    } else {
      msg = message;
      messcolor = 'red';
    }

    const { match } = this.props;
    const currentPath = `/edit-group/${match?.params?.id || ''}`;

    return (
      <div className="page">
        <CheckChanges path={currentPath} />
        <Topbar />
        <div className="page-content d-flex align-items-stretch">
          <Sidebar />
          <div className="content-inner">
            {/* <!-- Page Header--> */}
            <header className="page-header pb-1">
              <div className="container-fluid">
                <div className="d-flex align-items-center justify-content-between">
                  <h4>Groups Management</h4>
                </div>
              </div>
            </header>
            {/*  Breadcrumb */}
            <div className="breadcrumb-holder container-fluid">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/groups" className="text-primary">
                    Groups
                  </Link>
                </li>
                <li className="breadcrumb-item active">Edit Group</li>
              </ul>
            </div>
            <section className="forms">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-body">
                        <strong>
                          <p
                            className="text-center font-weight-light mb-4"
                            style={{ color: messcolor }}
                          >
                            {msg}
                          </p>
                        </strong>

                        <div className="form-horizontal">
                          <div className="row form-group">
                            <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                              Name
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9 col-sm-9">
                              <input
                                id="name"
                                type="text"
                                name="name"
                                required
                                data-msg="Please enter Name"
                                className="input-material"
                                value={this.state.name}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>

                          <div className="row form-group">
                            <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                              Company
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9 col-sm-9">
                              <Select
                                closeMenuOnSelect={true}
                                name="company"
                                options={companyData}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={selectedCompany}
                                onChange={e => this.handleCompanyInputChange(e)}
                              />
                            </div>
                          </div>

                          <div className="row form-group">
                            <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                              Stores
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9 col-sm-3">
                              <Select
                                isMulti
                                closeMenuOnSelect={false}
                                name="store"
                                options={storeData}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                value={selectedStores}
                                onChange={e => this.handleItemsInputChange(e)}
                              />
                            </div>
                          </div>

                          <div className="row form-group">
                            <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                              Description
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9 col-sm-9">
                              <textarea
                                id="description"
                                name="description"
                                required
                                data-msg="Please enter Description"
                                className="input-material"
                                value={this.state.description}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>

                          <div className="row form-group">
                            <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                              Territary
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9 col-sm-9">
                              <select
                                name="territary"
                                className="form-control text-capitalize mt-2"
                                required
                                data-msg="Please select territory"
                                value={this.state.territary}
                                onChange={this.handleInputChange}
                              >
                                <option value={config.INACTIVE}>Disabled</option>
                                <option value={config.ACTIVE}>Enabled</option>
                              </select>
                            </div>
                          </div>

                          <div className="row form-group">
                            <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">
                              Status
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9 col-sm-9">
                              <select
                                name="status"
                                className="form-control text-capitalize mt-2"
                                required
                                data-msg="Please select status"
                                value={this.state.status}
                                onChange={this.handleInputChange}
                              >
                                <option value={config.ACTIVE}>Active</option>
                                <option value={config.INACTIVE}>Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-group float-right mt-3">
                          <button
                            className="btn btn-primary"
                            disabled={!this.isGroupReady()}
                            onClick={this.handleSaveBtnClick}
                          >
                            Update Group
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    group: state.group?.groupGet || {},
    stores: state.store?.storeList || [],
    companies: state.company?.companies || [],
    groupStores: state.group?.storesByGroupGet || [],
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    companyList: function () {
      dispatch(companyList());
    },
    storesList: function (id: any) {
      dispatch(storesList(id));
    },
    getGroup: function (id: any) {
      dispatch(getGroup(id));
    },
    getStoreByGroup: function (id: any) {
      dispatch(getStoreByGroup(id));
    },
    updateGroup: function (id: any, data: any) {
      dispatch(updateGroup(id, data));
    },
    logoutUser: function () {
      dispatch(logoutUser());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGroup);


